import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";

interface AttachmentViewerProps {
  open: boolean;
  onClose: () => void;
  attachmentUrl: string;
  title?: string;
}

const AttachmentViewer: React.FC<AttachmentViewerProps> = ({
  open,
  onClose,
  attachmentUrl,
  title = "Attachment Preview",
}) => {
  // Check if the file is an image based on extension
  const isImage = attachmentUrl.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #e0e0e0",
          pb: 1,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "18px" }}>
          {title}
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          <Cancel />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ minHeight: "500px", p: 0, backgroundColor: "#f9f9f9" }}>
        {attachmentUrl ? (
          <Box
            sx={{
              width: "100%",
              height: "500px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#fff",
            }}
          >
            {isImage ? (
              <img
                src={attachmentUrl}
                alt="Attachment"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            ) : (
              <iframe
                src={attachmentUrl}
                title="Attachment"
                style={{ width: "100%", height: "100%", border: "none" }}
              />
            )}
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              height: "500px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="body1" color="textSecondary">
              No attachment available
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ borderTop: "1px solid #e0e0e0", p: 2 }}>
        <Button
          variant="outlined"
          onClick={() => window.open(attachmentUrl, "_blank")}
          disabled={!attachmentUrl}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          Open in New Tab
        </Button>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            background: "linear-gradient(90deg, #1976d2, #42a5f5)",
            "&:hover": {
              background: "linear-gradient(90deg, #1565c0, #1e88e5)",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AttachmentViewer;
